import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.instructions-azure', {
        url: '/instructions-azure',
        component: 'companyDirectoryIntegrationManageInstructionsAzure',
        resolve: {
        },
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/instructions-azure/directory-integration-instructions-azure.state.js